var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPurchase = function SvgPurchase(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m6.375 2.25-3 3.75v13.125c0 .497.202.974.561 1.326.36.351.847.549 1.356.549h13.416a1.94 1.94 0 0 0 1.356-.55c.36-.35.561-.828.561-1.325V6l-3-3.75H6.375Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M3.375 6v13.125c0 .497.202.974.561 1.326.36.351.847.549 1.356.549h13.416a1.94 1.94 0 0 0 1.356-.55c.36-.35.561-.828.561-1.325V6H3.375Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M3.375 6h17.25M15.75 9.75a3.75 3.75 0 0 1-7.5 0"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPurchase);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICA8cGF0aCBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjEuNSIgZD0ibTYuMzc1IDIuMjUtMyAzLjc1djEzLjEyNWMwIC40OTcuMjAyLjk3NC41NjEgMS4zMjYuMzYuMzUxLjg0Ny41NDkgMS4zNTYuNTQ5aDEzLjQxNmExLjk0IDEuOTQgMCAwIDAgMS4zNTYtLjU1Yy4zNi0uMzUuNTYxLS44MjguNTYxLTEuMzI1VjZsLTMtMy43NUg2LjM3NVoiLz4KICA8cGF0aCBmaWxsPSIjZmZmIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjEuNSIgZD0iTTMuMzc1IDZ2MTMuMTI1YzAgLjQ5Ny4yMDIuOTc0LjU2MSAxLjMyNi4zNi4zNTEuODQ3LjU0OSAxLjM1Ni41NDloMTMuNDE2YTEuOTQgMS45NCAwIDAgMCAxLjM1Ni0uNTVjLjM2LS4zNS41NjEtLjgyOC41NjEtMS4zMjVWNkgzLjM3NVoiLz4KICA8cGF0aCBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjEuNSIgZD0iTTMuMzc1IDZoMTcuMjVNMTUuNzUgOS43NWEzLjc1IDMuNzUgMCAwIDEtNy41IDAiLz4KPC9zdmc+Cg==";